var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelSubscriptionIcon = function SvgCancelSubscriptionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#cancel-subscription-icon_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC102",
    d: "M46.72 33.915c7.568-1.753 12.282-9.31 10.528-16.878S47.938 4.755 40.37 6.508s-12.282 9.31-10.528 16.878c1.753 7.569 9.31 12.282 16.878 10.529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB00",
    d: "M54.877 25.022c2.659-6.253-.255-13.477-6.508-16.136s-13.478.255-16.137 6.508c-2.658 6.253.255 13.478 6.509 16.137 6.253 2.659 13.477-.255 16.136-6.509"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.877 25.022c2.659-6.253-.255-13.477-6.508-16.136s-13.478.255-16.137 6.508c-2.658 6.253.255 13.478 6.509 16.137 6.253 2.659 13.477-.255 16.136-6.509",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDE00",
    d: "m37.103 7.703.634 1.658a12.3 12.3 0 0 0-2.852 2.113l-.593-1.855a14 14 0 0 1 2.811-1.916M42.193 7.982a12.3 12.3 0 0 0-2.937.695l-.722-1.611q1.304-.5 2.72-.736zM47.988 31.686l.726 1.61c-1.597.631-3.34.98-5.165.98-1.227 0-2.421-.159-3.557-.454l-.36-1.947c1.232.414 2.547.638 3.917.638 1.567 0 3.063-.295 4.44-.827M55.707 27.283a14.1 14.1 0 0 1-5.012 5.04l-.878-1.53a12.37 12.37 0 0 0 4.724-5.056z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB00",
    d: "M55.421 20.21c0 2.024-.505 3.926-1.4 5.595a11.88 11.88 0 0 1-6.46 5.578 11.8 11.8 0 0 1-4.012.695c-1.52 0-2.97-.285-4.303-.804-4.43-1.722-7.57-6.029-7.57-11.068a11.83 11.83 0 0 1 3.14-8.044 11.8 11.8 0 0 1 4.118-2.896c.929-.393 1.92-.671 2.953-.814a12 12 0 0 1 1.665-.115c6.556 0 11.87 5.314 11.87 11.872"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.83 23.007c0-2.716-2.628-3.435-4.544-3.96-1.153-.316-2.242-.614-2.242-1.187 0-.55 1.085-.665 1.994-.665.868 0 2.177.4 3.419 1.041.098.05.213.05.312-.003a.33.33 0 0 0 .172-.262l.228-2.346a.33.33 0 0 0-.166-.322c-.574-.33-1.784-.699-3.09-.824l.285-2.038a.34.34 0 0 0-.078-.265.34.34 0 0 0-.25-.115h-2.222a.33.33 0 0 0-.251.115.33.33 0 0 0-.078.265l.285 2.051c-2.76.383-3.754 2.096-3.754 3.612 0 2.21 2.268 2.906 4.093 3.466 1.258.386 2.445.749 2.445 1.454 0 .23 0 .767-1.784.767-1.756 0-3.048-.628-3.676-1.218a.34.34 0 0 0-.339-.071.33.33 0 0 0-.217.268l-.353 2.635a.33.33 0 0 0 .16.329c.715.424 2.004.742 3.421.854l-.281 1.95a.33.33 0 0 0 .078.265.34.34 0 0 0 .25.115h2.222a.33.33 0 0 0 .251-.115.33.33 0 0 0 .078-.265l-.285-1.984c3.395-.41 3.917-2.383 3.917-3.547",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC102",
    d: "M48.541 22.719c0-2.716-2.628-3.435-4.544-3.96-1.153-.316-2.241-.615-2.241-1.188 0-.55 1.085-.664 1.994-.664.868 0 2.177.4 3.418 1.04.098.052.214.052.312-.003a.33.33 0 0 0 .173-.26l.227-2.348a.33.33 0 0 0-.166-.322c-.573-.329-1.784-.698-3.09-.824l.285-2.038a.34.34 0 0 0-.078-.264.34.34 0 0 0-.25-.115h-2.222a.33.33 0 0 0-.25.115.33.33 0 0 0-.079.264l.285 2.052c-2.76.383-3.754 2.096-3.754 3.611 0 2.211 2.269 2.907 4.093 3.466 1.258.387 2.445.75 2.445 1.455 0 .23 0 .766-1.783.766-1.757 0-3.049-.627-3.676-1.217a.34.34 0 0 0-.34-.071.33.33 0 0 0-.216.268l-.353 2.634a.33.33 0 0 0 .16.33c.715.423 2.003.742 3.42.854l-.28 1.95a.33.33 0 0 0 .077.264.34.34 0 0 0 .251.116h2.221a.33.33 0 0 0 .251-.116.33.33 0 0 0 .078-.264l-.284-1.984c3.398-.41 3.916-2.38 3.916-3.547"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.021 25.805a11.9 11.9 0 0 1-4.737 4.798L38.934 9.267c.93-.394 1.92-.672 2.954-.814zM47.56 31.384a11.8 11.8 0 0 1-4.01.695c-1.52 0-2.971-.285-4.304-.804l-4.429-19.109a11.8 11.8 0 0 1 2.69-2.177z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__b)",
    d: "m30.845 56.03-17.063-8.324c0 9.136 3.765 14.028 4.883 15.404.051.075 5.873 6.453 5.873 6.453a1.4 1.4 0 0 0 1.925 0l3.476-3.344c.858-.825.906-10.19.906-10.19"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__c)",
    d: "m45.358 69.563-3.475-3.344c-.858-.826-.25-2.237.963-2.237h6.95c1.214 0 1.821 1.411.963 2.237l-3.475 3.344a1.4 1.4 0 0 1-1.926 0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__d)",
    d: "M26.099 35.397h-1.67c-1.725 0-2.932-1.641-2.357-3.206l.75-2.048c.758-2.064 3.754-2.162 4.655-.152l.918 2.047c.712 1.589-.499 3.36-2.296 3.36"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__e)",
    d: "M61.518 37.033c-.459 0-.926-.076-1.382-.234a.67.67 0 0 1-.422-.868.71.71 0 0 1 .901-.406c.67.233 1.393.202 2.038-.09a2.59 2.59 0 0 0 1.376-1.45 1.84 1.84 0 0 0-.07-1.465 1.95 1.95 0 0 0-1.125-.989 1.5 1.5 0 0 0-1.11.049 1.4 1.4 0 0 0-.75.79c-.192.51.083 1.075.612 1.259.17.06.354.051.517-.023a.66.66 0 0 0 .35-.368.71.71 0 0 1 .9-.406.67.67 0 0 1 .423.867c-.19.504-.571.906-1.076 1.134a2.15 2.15 0 0 1-1.593.07c-1.26-.44-1.913-1.782-1.457-2.994a2.78 2.78 0 0 1 1.476-1.556 2.94 2.94 0 0 1 2.187-.095 3.33 3.33 0 0 1 1.921 1.688c.386.791.428 1.68.119 2.5-.6 1.594-2.168 2.587-3.835 2.587"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__f)",
    d: "M66.656 47.707c0-11.695-11.836-19.312-26.437-19.312-14.6 0-26.437 7.618-26.437 19.312 0 9.689 12.493 18.513 12.493 18.513l3.475 3.344a1.4 1.4 0 0 0 1.926 0l3.036-2.921a40 40 0 0 0 5.507.376c2.948 0 5.783-.311 8.432-.903.03.035.058.07.093.104l3.475 3.344a1.4 1.4 0 0 0 1.926 0l3.475-3.344c.858-.826 9.036-11.21 9.036-18.513"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__g)",
    d: "M47.204 66.402 24.988 45.026a6 6 0 0 0-4.437-1.935h-5.594q-.265 0-.524.023a16.2 16.2 0 0 0-.65 4.59c0 3.918.692 7.053 1.57 9.467l11.994 11.54.76-.73 1.643 1.581a1.4 1.4 0 0 0 1.926 0l3.036-2.921a40 40 0 0 0 5.507.376c2.419 0 4.76-.213 6.985-.615"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__h)",
    d: "M48.628 66.12v-3.77h-9.456l-4.46 4.292c1.776.248 3.618.376 5.507.376 2.94 0 5.768-.31 8.41-.898"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__i)",
    d: "M25.44 42.198c.912 0 1.65-.71 1.65-1.587 0-.876-.738-1.587-1.65-1.587-.91 0-1.649.71-1.649 1.587s.739 1.587 1.65 1.587"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__j)",
    d: "M18.236 41.837c.703 0 1.274-.549 1.274-1.226s-.57-1.226-1.274-1.226-1.275.549-1.275 1.226.57 1.226 1.275 1.226"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__k)",
    d: "M20.551 54.455h-5.594c-3.261 0-5.905-2.544-5.905-5.682s2.644-5.682 5.905-5.682h5.594c3.262 0 5.905 2.544 5.905 5.682s-2.643 5.682-5.905 5.682"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__l)",
    d: "M12.91 51.523c1.171 0 2.121-1.231 2.121-2.75s-.95-2.75-2.121-2.75-2.121 1.231-2.121 2.75.95 2.75 2.12 2.75"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__m)",
    d: "M20.378 51.523c1.171 0 2.121-1.231 2.121-2.75s-.95-2.75-2.121-2.75-2.121 1.231-2.121 2.75.95 2.75 2.12 2.75"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__n)",
    d: "M34.592 34.473h-1.669c-1.725 0-2.932-1.641-2.358-3.206l.751-2.048c.757-2.064 3.753-2.162 4.654-.152l.918 2.047c.712 1.589-.498 3.36-2.296 3.36"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__o)",
    d: "M33.662 33.219h-.809c-.835 0-1.42-1.041-1.142-2.034l.364-1.299c.367-1.31 1.818-1.371 2.254-.096l.445 1.298c.345 1.008-.241 2.13-1.112 2.13"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-subscription-icon_svg__p)",
    d: "m48.707 41.122-4.46 4.93-12.184-11.723c.265.093.556.144.86.144h1.67c1.798 0 3.008-1.77 2.296-3.359l-.919-2.047a2.3 2.3 0 0 0-.236-.41l.011-.01z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__a",
    x1: 16.667,
    x2: 103.333,
    y1: 0,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__b",
    x1: 23.387,
    x2: 38.001,
    y1: 60.634,
    y2: 75.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__c",
    x1: 46.93,
    x2: 49.93,
    y1: 67.449,
    y2: 73.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__d",
    x1: 25.684,
    x2: 30.052,
    y1: 32.525,
    y2: 38.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__e",
    x1: 62.912,
    x2: 67.427,
    y1: 34.126,
    y2: 39.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__f",
    x1: 43.544,
    x2: 67.522,
    y1: 52.548,
    y2: 92.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__g",
    x1: 32.595,
    x2: 48.254,
    y1: 58.701,
    y2: 84.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__h",
    x1: 41.109,
    x2: 36.254,
    y1: 65.429,
    y2: 67.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__i",
    x1: 25.648,
    x2: 27.632,
    y1: 40.869,
    y2: 43.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172D59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__j",
    x1: 18.396,
    x2: 19.929,
    y1: 40.81,
    y2: 42.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172D59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__k",
    x1: 18.849,
    x2: 24.776,
    y1: 49.696,
    y2: 61.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__l",
    x1: 13.177,
    x2: 16.79,
    y1: 49.22,
    y2: 52.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172D59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__m",
    x1: 20.645,
    x2: 24.258,
    y1: 49.22,
    y2: 52.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172D59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__n",
    x1: 34.178,
    x2: 38.546,
    y1: 31.601,
    y2: 37.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__o",
    x1: 33.128,
    x2: 31.777,
    y1: 31.737,
    y2: 31.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-subscription-icon_svg__p",
    x1: 39.714,
    x2: 32.819,
    y1: 40.126,
    y2: 41.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008DFF"
  })))));
};
export default SvgCancelSubscriptionIcon;